import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/appboard/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/appboard/';

class AppBoardService {
  getPublicContent() {
    return axios.get(API_URL + 'all');
  }

  getDashboardContent() {
    return axios.get(API_URL + 'dashboard');
  }

  getUserBoard() {
    return axios.get(API_URL + 'user', { headers: authHeader() });
  }

  getManagerBoard() {
    return axios.get(API_URL + 'man', { headers: authHeader() });
  }

  getAuditorBoard() {
    return axios.get(API_URL + 'aud', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(API_URL + 'admin', { headers: authHeader() });
  }

  getSuperAdminBoard() {
    return axios.get(API_URL + 'superadmin', { headers: authHeader() });
  }
}

export default new AppBoardService();